export default "__VITE_ASSET__CALbR9x5__"